import React, { useState, useEffect } from "react";
import Navbar from "../../../components/Navbar";
import SideBar from "../../../components/SideBar";
import Dynamic_PR_table from "../components/Dynamic_PR_table";
import { useParams } from "react-router-dom";
import { API_URL } from "../../../constants";
import {
  GetServiceCaller,
  PostServiceCaller,
  PostFormServiceCaller,
} from "../../../services/serviceCaller";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../constants/layout/store/filterSlice";

const AmendmentLog = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(updateNavbarHeading("Amendment Log"))
  }, [])

  const columns = {
    fieldName: { text: " Field Name", align: "start" },
    updated: { text: "Updated", align: "start" },
    previous: { text: "Previous", align: "start" },
    updatedDate: { text: "Updated Date", align: "center" },
    username: { text: "Updated By", align: "center" },
  };
  const defaultColumns = {
    fieldName: true,
    updated: true,
    previous: true,
    updatedDate: true,
    username: true,
  };

  console.log("test Id in amendentmentlog", id);

  const [searchTerm, setSearchTerm] = useState("");

  const [amendmentList, setAmendmentList] = useState([]);
  const [loading, setLoading] = useState();

  useEffect(() => {
    fetchAmendementLog(id);
  }, [id]);

  const fetchAmendementLog = async (id) => {
    try {
      const response = await GetServiceCaller(`${API_URL}rom-log/${id}`);
      if (response.status === 200) {
        const cleanedData = response.data.amendent_log;
        console.log("cleanedData", cleanedData);
        setAmendmentList(cleanedData);
        setLoading(false);
      } else {
        console.error(
          "Failed to fetch partnerMaster. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error fetching PartnerMaster:", error);
    }
  };

  return (
    <>


      <div className="container-fluid" id="skill_section">
       <div className="container-fluid" id="skill-table-area">
        <div className="row">
          <Dynamic_PR_table
            data={amendmentList}
            columns={columns}
            defaultColumns={defaultColumns}
            itemsPerPage={10}
            searchTerm={searchTerm}
            setSearchTerm={setSearchTerm}
            showIcon1={false}
            showIcon2={false}
            showIcon3={false}
            showIcon4={false}
            showIcon5={false}
            isActionRequired={false}
            isCheckBoxRequired={false}
            //   handleCheckboxChange={handleCheckboxChange}
            //   handleSelectAllChange={handleSelectAllChange}
            icons={{
              Icon1: <i className="bi bi-pencil-square icons"></i>,
              Icon2: <i className="bi bi-trash-fill icons"></i>,
              Icon3: <i className="bi bi-eye-fill icons"></i>,
              Icon4: <i className="bi bi-person-plus icons"></i>,
            }}
          />
        </div>
        </div>
      </div>

    </>
  );
};

export default AmendmentLog;
